import * as React from 'react';
import { VtxColumnProps } from '@vertexinc/vtx-ui-react-component-library';
import {
  CertificateReportStatus,
  DateFormatEnum,
  formatDateTime,
  StatusIndicator,
} from '@vcd-ecm-ui/Common';
import GridRowData from './GridRowData';

const columns: VtxColumnProps<GridRowData>[] = [
  {
    title: 'Generation Date',
    dataIndex: 'startDateTime',
    render: (value, row: GridRowData, index: number) => (value
      ? formatDateTime(value, ' ', { dateFormat: DateFormatEnum.WMDY, month: 'short', dateSeperator: ' ' })
      : null),
    sorter: true,
    width: 230,
    fixed: 'left',
  },
  {
    title: 'Report Name',
    dataIndex: 'reportName',
    className: 'reportColumnStyle',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'Created By',
    dataIndex: 'createdBy',
    className: 'reportColumnStyle',
    sorter: true,
  },
  {
    title: 'Report Status',
    dataIndex: 'status',
    sorter: true,
    // eslint-disable-next-line react/destructuring-assignment
    render: (value, row: GridRowData, index: number) => <StatusIndicator status={value.toString()} />,
    width: 150,
  },
  {
    title: 'Action',
    dataIndex: 'action',
    width: 150,
    align: 'center',
    fixed: 'right',
  },
];

const getDefaultColumns = (): VtxColumnProps<GridRowData>[] => columns;

export default getDefaultColumns;
